(function () {
    var $body = $('body');
    var facetDate = {
        sliderRanges: [],
        sliderValues: [],
        $rangeStart: $('.range-slider__start'),
        $rangeEnd: $('.range-slider__end'),
        url: location.href,

        init: function () {
            if (config.enableFacetRangeDate) {
                facetDate.sliderRanges = [];
                facetDate.sliderValues = [];

                facetDate.$rangeStart = $('.range-slider__start');
                facetDate.$rangeEnd = $('.range-slider__end');
                facetDate.initRange();
            }
            facetDate.control();
        },
        control: function () {
            $body.on('click', '.custom-date', function (e) {
                e.preventDefault();
                facetDate.on.toggle($(this));
            });

            $(document).on('UX-attach', function () {
                facetDate.init();
            });
            if (config.enableFacetRangeDate) {
                $(document).on('UX-detach', function () {
                    window.jcf.destroy($('.range-slider__range'));
                });

                $('.range-slider__range').change(function () {
                    facetDate.on.setRange($(this));
                });

                facetDate.$rangeStart.on('change', function () {
                    facetDate.on.setStart($(this));
                });

                facetDate.$rangeEnd.on('change', function () {
                    facetDate.on.setEnd($(this));
                });

                $('.range-slider__range').on('change change:startend', function () {
                    facetDate.updateUrl($(this));
                });
            }
        },
        on: {
            toggle: function (elem) {
                var $toggle = elem.closest('.facet');
                $toggle.find('.custom-date-form').slideToggle();
                elem.toggleClass('js--open');
            },
        },
    };
    if (config.enableFacetRangeDate) {
        facetDate.getSelectedRange = function (sliderRange) {
            const queryString = facetDate.url.indexOf('?') !== -1 ? facetDate.url.split('?')[1] : '';
            const queryStringObj = {};

            if (queryString) {
                queryString.split('&').map(function (value) {
                    const keyVal = value.split('=');
                    queryStringObj[keyVal[0]] = keyVal[1];
                });

                if (queryStringObj.AfterYear && queryStringObj.BeforeYear) {
                    return [queryStringObj.AfterYear, queryStringObj.BeforeYear];
                }
            }

            return [parseInt(sliderRange.attr('data-min'), 10), parseInt(sliderRange.attr('data-max'), 10)];
        };

        facetDate.getSelectedRangePosition = function (start, end) {
            var closestStart;
            var closestEnd;

            if (facetDate.sliderValues.indexOf(start) < 0) {
                closestStart = facetDate.sliderValues.reduce(function (prev, curr) {
                    return Math.abs(curr - start) < Math.abs(prev - start) ? curr : prev;
                });
            }

            if (facetDate.sliderValues.indexOf(end) < 0) {
                closestEnd = facetDate.sliderValues.reduce(function (prev, curr) {
                    return Math.abs(curr - end) < Math.abs(prev - end) ? curr : prev;
                });
            }

            return [
                facetDate.sliderValues.indexOf(closestStart || start),
                facetDate.sliderValues.indexOf(closestEnd || end),
            ];
        };

        facetDate.initRange = function () {
            $('.range-slider').each(function () {
                const $sliderRange = $(this).find('.range-slider__range');
                if (!$sliderRange.hasClass('jcf-hidden')) {
                    const frequencies = $sliderRange.data('frequencies');

                    const nonLinearSliderSteps = [1, 2, 5, 10];
                    const allowedTotalYears =
                        nonLinearSliderSteps.reduce(function (prev, cur) {
                            return prev + cur;
                        }) * 2;
                    const minVal = parseInt($sliderRange.attr('data-min') || $sliderRange.attr('min'), 10);
                    const maxVal = parseInt($sliderRange.attr('data-max') || $sliderRange.attr('max'), 10);
                    const totalYears = maxVal - minVal;
                    const linearSlider = $sliderRange.attr('data-slider-type') === 'linear';

                    if (totalYears > allowedTotalYears && !linearSlider) {
                        // non-linear slider
                        const displaySteps = nonLinearSliderSteps.slice().reverse();
                        let remaining = totalYears;
                        let startYear = minVal;
                        let startSlice = 0;

                        displaySteps.forEach(function (step, i, all) {
                            const oneThird = Math.floor(remaining / 3);
                            let twoThirds = Math.floor(2 * oneThird);
                            const remainder = twoThirds % step;
                            if (remainder > 0) {
                                twoThirds = twoThirds - remainder;
                            }
                            remaining = remaining - twoThirds;

                            if (i === displaySteps.length - 1) {
                                facetDate.sliderRanges.push({
                                    start: startYear,
                                    stop: maxVal,
                                    displayStep: nonLinearSliderSteps[i],
                                    slideStep: step,
                                    freq: frequencies.slice(startSlice, frequencies.length),
                                });
                            } else {
                                facetDate.sliderRanges.push({
                                    start: startYear,
                                    stop: startYear + twoThirds,
                                    displayStep: nonLinearSliderSteps[i],
                                    slideStep: step,
                                    freq: frequencies.slice(startSlice, startSlice + twoThirds),
                                });
                            }
                            startSlice = startSlice + twoThirds;
                            startYear = startYear + twoThirds;
                        });

                        facetDate.sliderRanges.forEach(function (range) {
                            let sliderVal = range.start;
                            while (sliderVal <= range.stop) {
                                if (facetDate.sliderValues.indexOf(sliderVal) < 0) {
                                    facetDate.sliderValues.push(sliderVal);
                                }
                                sliderVal += range.slideStep;
                            }
                        });
                    } else {
                        // linear slider
                        if (!facetDate.sliderValues.length > 0) {
                            for (let i = minVal; i <= maxVal; i++) {
                                facetDate.sliderValues.push(i);
                            }
                        }
                    }

                    $sliderRange.attr('min', 0);
                    $sliderRange.attr('max', facetDate.sliderValues.length - 1);
                    const initialValue = facetDate.getSelectedRange($sliderRange);
                    facetDate.$rangeStart.val(initialValue[0]);
                    facetDate.$rangeEnd.val(initialValue[1]);
                    const initialPosition = facetDate.getSelectedRangePosition(initialValue[0], initialValue[1]);
                    $sliderRange.attr('value', initialPosition.join(','));
                    window.jcf.replace($sliderRange);

                    // render frequencies
                    if (frequencies) {
                        const $rangeWrapper = $(this).find('.jcf-range-wrapper');
                        const $rangeFrequencies = $('<span class="jcf-range-frequencies"></span>');

                        if (totalYears > allowedTotalYears && !linearSlider) {
                            // non-linear slider
                            facetDate.sliderRanges.forEach(function (range) {
                                for (let i = 0; i < range.freq.length; i++) {
                                    const $rangeSlice = $(
                                        '<span class="jcf-range-frequencies__slice" style="width: ' +
                                            100 / range.freq.length / facetDate.sliderRanges.length +
                                            '%; opacity: ' +
                                            range.freq[i] +
                                            '"></span>'
                                    );
                                    $rangeFrequencies.append($rangeSlice);
                                }
                            });
                            $rangeWrapper.prepend($rangeFrequencies);
                        } else {
                            // linear slider
                            const rangeSliceWidth = 100 / frequencies.length;
                            for (let i = 0; i < frequencies.length; i++) {
                                const $rangeSlice = $(
                                    '<span class="jcf-range-frequencies__slice" style="width: ' +
                                        rangeSliceWidth +
                                        '%; opacity: ' +
                                        frequencies[i] +
                                        '"></span>'
                                );
                                $rangeFrequencies.append($rangeSlice);
                            }
                            $rangeWrapper.prepend($rangeFrequencies);
                        }
                    }
                }
            });
        };

        facetDate.on.setRange = function (elem) {
            const $toggle = elem.closest('.range-slider');
            const $target = $toggle.find('.jcf-active-handle');

            const tmp = $target.attr('class').match(/jcf-index[\w-]*\b/);
            const tmp2 = tmp.toString().split('-')[2];
            $('input.index-' + tmp2).val(facetDate.getValue(elem));
        };
        facetDate.on.setStart = function (elem) {
            const $sliderRange = elem.closest('.range-slider').find('.range-slider__range');
            const minVal = parseInt($sliderRange.attr('min'), 10);
            const thisVal = facetDate.getValueFromInput(elem);
            const sliderInstance = window.jcf.getInstance($sliderRange);
            if (thisVal >= minVal && thisVal <= sliderInstance.values[1]) {
                sliderInstance.values[0] = thisVal.toString();
                sliderInstance.refresh();
                $sliderRange.trigger('change:startend');
            }
        };
        facetDate.on.setEnd = function (elem) {
            const $sliderRange = elem.closest('.range-slider').find('.range-slider__range');
            const maxVal = parseInt($sliderRange.attr('max'), 10);
            const thisVal = facetDate.getValueFromInput(elem);
            const sliderInstance = window.jcf.getInstance($sliderRange);
            if (thisVal <= maxVal && thisVal >= sliderInstance.values[0]) {
                sliderInstance.values[1] = thisVal.toString();
                sliderInstance.refresh();
                $sliderRange.trigger('change:startend');
            }
        };

        facetDate.on.rangeUpdate = function (elem, callbackFn) {
            var $sliderRange = $(elem);
            $sliderRange.on('change change:startend', function () {
                callbackFn(facetDate.$rangeStart.val(), facetDate.$rangeEnd.val());
            });
        };
        facetDate.updateUrl = function (elem) {
            var url = new URL(facetDate.url);
            url.searchParams.set('AfterYear', facetDate.$rangeStart.val());
            url.searchParams.set('BeforeYear', facetDate.$rangeEnd.val());
            url.searchParams.set('queryID', $(elem).attr('data-queryID'));
            window.location = url;
        };
        facetDate.removeParam = function (key) {
            var baseUrl = facetDate.url.split('?')[0];
            var queryString = facetDate.url.indexOf('?') !== -1 ? facetDate.url.split('?')[1] : '';
            var queryStringObj = {};

            if (queryString) {
                queryString.split('&').map(function (value) {
                    var keyVal = value.split('=');
                    queryStringObj[keyVal[0]] = keyVal[1];
                });
                if (queryStringObj[key]) {
                    delete queryStringObj[key];
                }
                queryString = Object.keys(queryStringObj)
                    .map(function (value) {
                        return value + '=' + queryStringObj[value];
                    })
                    .join('&');
                facetDate.url = baseUrl + (queryString ? '?' + queryString : '');
            }
        };
        facetDate.getValue = function (elem) {
            var thisValIndex = parseInt(elem.val(), 10);
            var thisVal = facetDate.sliderValues[thisValIndex];

            return thisVal;
        };
        facetDate.getValueFromInput = function (elem) {
            var $sliderRange = elem.closest('.range-slider').find('.range-slider__range');
            var customVal = parseInt(elem.val(), 10);
            var minVal = parseInt($sliderRange.attr('data-min'), 10);
            var maxVal = parseInt($sliderRange.attr('data-max'), 10);
            var thisVal;

            if (customVal <= maxVal && customVal >= minVal) {
                if (facetDate.sliderValues.indexOf(customVal) >= 0) {
                    thisVal = facetDate.sliderValues.indexOf(customVal);
                } else {
                    const closest = facetDate.sliderValues.reduce(function (prev, curr) {
                        return Math.abs(curr - customVal) < Math.abs(prev - customVal) ? curr : prev;
                    });
                    thisVal = facetDate.sliderValues.indexOf(closest);
                }
            }
            return thisVal;
        };
    }
    UX.facetDate = facetDate; // add to global namespace
})();
